// extracted by mini-css-extract-plugin
export default {"button":"_7bb23352","arrow":"_19999c5d","expanded":"_c09dce03"};